// Միասնական հաշվի մնացորդ
const tax_balance_help_icon_1_title = {
    am: `Միասնական հաշիվը հարկ վճարողների հարկային պարտավորությունների մարման նպատակով գանձապետարանի կողմից վարվող պետական հաշիվ է: Միասնական հաշվին են փոխանցվում գրեթե բոլոր հարկատեսակների գծով վճարումները՝ ԱԱՀ, եկամտային հարկ, շահութահարկ, շրջանառության հարկ:
<br /><br />
Հարկ վճարողները կարող են նաև հետ ստանալ միասնական հաշվին ավել փոխանցված գումարները։`,

    en: `Single account balance is a state-managed account maintained by the Treasury to facilitate the settlement of taxpayers' tax liabilities. Nearly all types of tax payments are transferred to the Unified Account, including VAT, income tax, profit tax, and turnover tax.
<br /><br />
Taxpayers may also request a refund for overpaid amounts in the Single Account․`,

    ru: `Баланс единого счета - это государственный счет, который ведет Казначейство для упрощения урегулирования налоговых обязательств налогоплательщиков. На Единый счет перечисляются практически все виды налоговых платежей, включая НДС, подоходный налог, налог на прибыль и налог с оборота.
<br /><br />
Налогоплательщики также могут запросить возврат переплаченных сумм на Едином счете․`
}

// Սոցիալական ծախսեր
const tax_balance_help_icon_2_title = {
    am: `Սոցիալական ծախսեր կրող ֆիզիկական անձը իրավունք ունի փոխհատուցում ստանալ իր եկամտահարկից ինչպես իր, այնպես էլ իր ընտանիքի անդամների համար: Ընտանիքի անդամներն են՝ անհատի ամուսինը, ծնողները և երեխաները (ներառյալ որդեգրված երեխաները և որդեգրողները):
<br /><br />
<b>Իրավասու սոցիալական ծախսեր.</b>
<ul>
<li>Առողջության ապահովագրության փաթեթի գնում Հայաստանում գործող ապահովագրական ընկերություններից.</li>
<li>Հայաստանում գործող ուսումնական հաստատություններին ուսման վարձերի վճարում.</li>
</ul>
Փոխհատուցում ստանալու համար ֆիզիկական անձինք պետք է վճարման պահին ծառայություն մատուցողից պահանջեն հաշվարկային փաստաթուղթ (invoice)\` ներկայացնելով անձը հաստատող փաստաթուղթ և ՀԾՀ։ Իսկ ընտանիքի անդամի դեպքում՝ նաև նրա անձը հաստատող փաստաթուղթը և ՀԾՀ-ն։
<br /><br />
<b>Առավելագույն տարեկան փոխհատուցման սահմանաչափերը.</b>
<ul>
<li><b>Առողջապահություն</b>՝ 50000 դրամ</li>
<li><b>Կրթություն</b>՝ 100000 դրամ</li>
<li><b>Ընդհանուր բոլոր կատեգորիաներում</b>՝ 100000 դրամ</li>
</ul>`,

    en: `An individual who incurs social costs is entitled to compensation from their income tax for both themselves and their family members. Family members include the individual's spouse, parents, and children (including adopted children and adoptive parents).
<br /><br />
<b>Eligible Social Expenses:</b>
<ul>
<li>Purchasing a health insurance package from insurance companies operating in Armenia.</li>
<li>Paying tuition fees to educational institutions operating in Armenia.</li>
</ul>
To receive compensation, individuals must request a billing document (invoice) from the service provider at the time of payment. They must also present an identity document and a personal identification number. If the expense is for a family member, their identity document and personal identification number must also be provided.
<br /><br />
<b>Maximum Annual Compensation Limits:</b>
<ul>
<li><b>Healthcare:</b> 50,000 drams</li>
<li><b>Education:</b> 100,000 drams</li>
<li><b>Total across all categories:</b> 100,000 drams</li>
</ul>`,

    ru: `Лицо, несущее социальные расходы, имеет право на компенсацию из своего подоходного налога как за себя, так и за членов своей семьи. Членами семьи являются супруг(а), родители и дети (включая усыновленных детей и усыновителей) лица.
<br /><br />
<b>Приемлемые социальные расходы:</b>
<ul>
<li>Приобретение пакета медицинского страхования в страховых компаниях, действующих на территории Армении.</li>
<li>Оплата обучения в образовательных учреждениях, действующих на территории Армении.</li>
</ul>
Для получения компенсации физические лица должны запросить расчетный документ у поставщика услуг в момент оплаты, предъявив документ, удостоверяющий личность, и номер социального страхования. А в случае члена семьи — также его удостоверение личности и номер социального страхования.
<br /><br />
<b>Максимальные годовые лимиты компенсации:</b>
<ul>
<li><b>Здравоохранение:</b> 50 000 драмов</li>
<li><b>Образование:</b> 100 000 драмов</li>
<li><b>Всего по всем категориям:</b> 100 000 драмов</li>
</ul>`
}

export const dataContent: any = { tax_balance_help_icon_1_title, tax_balance_help_icon_2_title }